// Demo URL for reference platform — set REACT_APP_SPORT_PROJECT_URL in .env for production
export const SPORT_PROJECT_DEMO_URL =
  process.env.REACT_APP_SPORT_PROJECT_URL || "http://localhost:5174";

/** Featured visual — product / demo screenshot (preview panel is light; see FeaturedProject.css) */
export const SPORT_PROJECT_IMAGE = "/SystemScreenShot.png";
